import { AccessionType, ValidationType } from "./rna-cish/ProbeSetForm";
import { ProbeSetFamily, } from "./rna-cish/RnaCatalog";
export var findOrganism = function (slo, catalog) {
    // Goes to "no organism selected" UI state when undefined
    return catalog.probeSet.catalog.organisms.find(function (o) { return o.id === slo.id; });
};
export var findOrganismByName = function (orgName, catalog) {
    return catalog.probeSet.catalog.organisms.find(function (o) {
        return o.name.trim().toLowerCase() === orgName.trim().toLowerCase();
    });
};
export var targetHasMIValidatedEntry = function (target) {
    if (target instanceof ProbeSetFamily) {
        return target.variants.find(function (v) {
            return v.validated === ValidationType.MI_VALIDATED;
        }) != null;
    }
    else {
        return target.variants.find(function (v) {
            return v.validated === ValidationType.MI_VALIDATED;
        }) != null;
    }
};
export var isPredictedTarget = function (target) {
    return target.accessions.every(function (a) {
        return a.accessionType === AccessionType.PREDICTED;
    });
};
//# sourceMappingURL=KitToFormStateUtilityFunctions.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/KitToFormStateUtilityFunctions.js
// module id = 113
// module chunks = 0